import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { IncomeStatementSection } from '@/features/reports/income-statement'

/** Income against expense over a period, as an addressable screen of its own. */
export function ReportsIncomeStatementPage() {
  return (
    <>
      <Link
        to="/reports"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All reports
      </Link>

      <PageHeader
        title="Income statement"
        description="Income against expense over a period — the profit-and-loss view of the ledger's own account movement."
      />

      <IncomeStatementSection />
    </>
  )
}
